import React from 'react';
import classNames from 'classnames';
import { Toast } from 'antd-mobile';

import styles from './index.module.less';

import imageDownload from '../../public/images/download-app.png';

import { getOpenAccountConfig } from '../../service/chat-service';
import tools from '../../utils/tools';

import success from '../../public/images/icon_success.png';

class Node extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curKey: 0,
      data: null,
    };
  }

  componentDidMount() {
    const productId = tools.getQueryString('productId');
    Toast.loading();
    getOpenAccountConfig(productId)
      .then((res) => {
        if (res.code === 10000) {
          this.setState({
            data: res.data,
          });
        }
      })
      .finally(Toast.hide);
  }

  handleClick = (key) => {
    this.setState({
      curKey: key,
    });
  }

  // 渲染子元素
  renderContent = () => {
    const { data, curKey } = this.state;
    const current = data[curKey];
    const yindaoEl = <div className={styles.yindao}>{current.guideTitle}</div>;
    const isQrcode = current.guideType === 1;
    return (
      <div>
        {isQrcode ? (
          <div>
            <img className={styles.download} src={current.guideUrl} alt="" />
          </div>
        ) : (
          <a href={current.guideUrl} target="__blank">
            <img className={styles.download} src={imageDownload} alt="" />
          </a>
        )}
        {yindaoEl}
      </div>
    );
  }

  render() {
    const { curKey, data } = this.state;
    if (!data) return null;
    const isTwo = data.length === 2;
    return (
      <>
        <div className={styles.status}>
          <img className={styles.icon} src={success} alt="" />
          <span>开户成功</span>
        </div>
        {isTwo && (
          <div className={styles.btn_group}>
            <div
              onClick={this.handleClick.bind(null, 0)}
              className={classNames(styles.btn, {
                [styles.active]: curKey === 0,
              })}
              role="button"
              tabIndex={0}
            >
              体验APP
            </div>
            <div
              onClick={this.handleClick.bind(null, 1)}
              className={classNames(styles.btn, {
                [styles.active]: curKey === 1,
              })}
              role="button"
              tabIndex={0}
            >
              体验小程序
            </div>
          </div>
        )}
        {this.renderContent()}
      </>
    );
  }
}

export default Node;
